/* eslint-disable */
export enum SubUnitsActionTypes {
  SET_CUSTOMER = "@@SubUnits/SET_CUSTOMER",
  CREATE_CUSTOMER = "@@SubUnits/CREATE_CUSTOMER"
}
